import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import PaymentDetailsModel from '../CustomEntitlementCardPayments/PaymentDetailsModel';
/**
 * Contains the selectors that select state from the 'UAPayments' store object.
 *
 * @export
 * @namespace PaymentsSelectors
 */
var selectors = /*#__PURE__*/_createClass(function selectors() {
  _classCallCheck(this, selectors);
});
/**
 * @private
 */
_defineProperty(selectors, "moduleIdentifier", 'UAPayments');
/**
 * Retrieves the payments data from the store.
 *
 * @param {Object} state The initial state for the reducer.
 * @returns {*} The payment data from the store.
 *
 * @function
 * @static
 * @memberof PaymentsSelectors
 */
_defineProperty(selectors, "selectData", function (state) {
  return state[selectors.moduleIdentifier].data.payload;
});
/**
 * Retrieves the status of fetching the payments from the store.
 * @param {Object} state The initial state for the reducer.
 * @returns {*} The status of request for payments data from the server.
 *
 * @function
 * @static
 * @memberof PaymentsSelectors
 */
_defineProperty(selectors, "isProcessing", function (state) {
  return state[selectors.moduleIdentifier].isProcessing.payload;
});
/**
 * Retrieves the error associated with updating the store payments data details.
 * @param {Object} state The initial state for the reducer.
 * @returns {*} The error object if there was an error when requesting the payments data from the
 * server.
 *
 * @function
 * @static
 * @memberof PaymentsSelectors
 */
_defineProperty(selectors, "selectError", function (state) {
  return state[selectors.moduleIdentifier].error.payload;
});
/**
 * Comparator function used to order the list of payments in chronological order,
 * starting with the latest payment.
 *
 * @param {Object} leftPayment The first payment details for comparison.
 * @param {Object} rightPayment The second payment details for comparison.
 * @function
 * @static
 * @memberof PaymentsSelectors
 */
_defineProperty(selectors, "sortedByDateSelector", function (leftPayment, rightPayment) {
  return leftPayment.paymentDate > rightPayment.paymentDate ? -1 : 1;
});
/**
 * Finds an specific payment within a list of payments.
 *
 * @param payments a list of payments to iterate over.
 * @param paymentId a payment id to be found.
 * @function
 * @static
 * @memberof PaymentsSelectors
 */
_defineProperty(selectors, "findSpecificPayment", function (payments, paymentId) {
  return _findInstanceProperty(payments).call(payments, function (payment) {
    return payment.paymentId === paymentId;
  });
});
/**
 * Finds an specific payment within a list of payments.
 *
 * @param payments a list of payments to iterate over.
 * @param paymentId a payment id to be found.
 * @function
 * @static
 * @memberof PaymentsSelectors
 */
_defineProperty(selectors, "getSpecificPaymentModel", function (payments, paymentId) {
  var specificPayment = _findInstanceProperty(payments).call(payments, function (payment) {
    return payment.paymentId === paymentId;
  });
  return specificPayment ? new PaymentDetailsModel.PreviousPaymentDetails(specificPayment) : null;
});
/**
 * Retrieve the benefit details to be displayed on the payments list page. Each payment within
 * the yearly payment grouping is evaluated. For a yearly payment grouping each payment details
 * record is passed in as a parameter 'current' together with an empty list initially.
 * If the caseID of the current payment details matches one of the partial payment records,
 * the payment record index where the matching element was found in the array is returned and
 * the payment details record 'current' is added to the list of payments within its group details
 * at this index of the list.
 * Otherwise if it is not found a new list of group details is created and the current payment
 * record added to that list.
 *
 * @param {Object} partial The payments list is an empty list where payment items are added to
 * the list when evaluated .
 * @param {Object} current A payment details record.
 * @returns {Object} The list of payments records and the inner list of group details payment
 * record list.
 * @function
 * @static
 * @memberof PaymentsSelectors
 */
_defineProperty(selectors, "benefitsReducerSelector", function (partial, current) {
  var accumulated = partial;
  var next = current;
  var existingIndex = _mapInstanceProperty(accumulated).call(accumulated, function (benefit) {
    return benefit.caseId;
  }).indexOf(next.caseId);
  if (existingIndex < 0) {
    next.groupedDetails = [];
    next.groupedDetails.push(current);
    accumulated.push(next);
  } else {
    accumulated[existingIndex].groupedDetails.push(current);
  }
  return accumulated;
});
/**
 * Creates the yearly payment list. The returned partial list contains a inner list of payment
 * by year, for example the partial list may contain three lists of payments where list one are
 * payments from the year 2011 and list two contains payments from 2015 and list three contains
 * payments from 2017.
 * The function paymentsReducerSelector takes in two parameters. Firstly the partial list
 * contains a inner list of payments grouped by year. This list is initially set to empty
 * when accessed originally. The second parameter is a payment record payment being evaluated
 * where the record is added to the last inner list or a new inner list item is created with
 * the current record.
 * If the current payment being evaluated has a paymentDate year equal to the paymentDate year
 * of the payment in the last yearly grouping list within the partial list, the current record
 * is added to the list, otherwise a new list of items is created within the partial list adding
 * the current item.
 *
 * @param {Object} partial The list containing payment lists grouped by year.
 * @param {Object} current The current payment being evaluated to add to partial grouping list
 * by year.
 * @returns {Object} The list of payments grouped by year of payment.
 * @function
 * @static
 * @memberof PaymentsSelectors
 */
_defineProperty(selectors, "paymentsReducerSelector", function (partial, current) {
  if (partial.length > 0 && current.paymentDate.getYear() === partial[partial.length - 1][0].paymentDate.getYear()) {
    partial[partial.length - 1].push(current);
  } else {
    partial.push([current]);
  }
  return partial;
});
export { selectors as default };